import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const ScheduleDemoBannerRoot = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  padding-top: 12px;
  border: 1px solid var(--action-primary-default);
  ${borderRadius.r3};
  background-color: var(--action-primary-soft-hover);
  position: relative;
`;

export const Content = styled.div`
  padding: 0 12px 12px 12px;
`;

export const Title = styled.h3`
  ${typographyV2.titleSm};
`;

export const Description = styled.p`
  margin-bottom: 8px;
  ${typographyV2.bodyXs};
  color: var(--text-soft);
`;

export const StyledLink = styled.a`
  position: absolute;
  bottom: 12px;
  padding: 6px 12px;
  ${borderRadius.r2};
  ${typographyV2.bodyXs};
  color: var(--text-on-primary);
  background-color: var(--action-primary-default);
`;
